import React, { useState } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { useNow } from "src/hooks"
import { Box } from "@infotech/uikit-grid"
import FieldSet from "@infotech/uikit-fieldset"
import { components } from "@infotech/uikit-select"
import InfinitySelect from "src/components/Selects/InfinitySelect"
import cn from "classnames"
import { updateList } from "src/engine/modules/lists/actions/creators/update"
import {
  DEFAULT_COLOR,
  makeTransparent,
} from "src/containers/Calendar/helpers/eventToItem"
import get from "lodash/get"
import { selectCurrentList } from "src/engine/modules/lists/selectors"
import { useAvailableList } from "src/hooks/useAvailableList"
import { LIST_NAME, getBasicUrl } from "./helper"
import List from "./Lists"
import ReadOnlyList from "./Lists/readOnlyList"
import styles from "./styles.css"

const createFirstText = `Чтобы добавить типы событий, создайте план.`

const EventTypeWrapper = ({ color, label }) => (
  <Box flex loose p="1md" className={styles.Option}>
    <Box loose className={styles.CircleWrapper}>
      <div
        className={styles.circle}
        style={{
          backgroundColor: `${
            color === `#fff` ? DEFAULT_COLOR : makeTransparent(color, 0.4)
          }`,
        }}
      />
    </Box>
    <Box pt="4px" loose className={cn(styles.SelectDropdownOptionLabel)}>
      {label}
    </Box>
  </Box>
)

EventTypeWrapper.propTypes = {
  color: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
}

const Option = ({ data, ...props }) => (
  <components.Option data={data} {...props}>
    <EventTypeWrapper {...data} />
  </components.Option>
)

const EventTypePart = ({
  planEventTypeList,
  plan: { isVirtual, id },
  plan,
  updateList,
  planTypeId,
  isDisabled,
}) => {
  const planUuid = get(plan, `data.uuid`)
  const [availableQuery, setQuery] = useState({ limit: 30, offset: 0 })

  const [refreshTimestamp, refreshList] = useNow()

  const { data, pending } = useAvailableList({
    params: {
      url: `/plans/${planUuid}/events/types/available`,
      body: availableQuery,
    },
    trigger: availableQuery,
    extraTrigger: Boolean(planUuid) && !isVirtual,
    refresh: refreshTimestamp,
    hold: Boolean(planUuid) && !isVirtual,
  })
  const eventTypesOptions = data.map(item => ({
    value: item.id,
    label: item.name,
    color: item.color,
    data: item,
  }))

  return (
    <Box loose>
      <Box loose pl="2md" pr="2md" pt="2md">
        <FieldSet caption="Типы событий">
          <div data-testid="plans-event-types-select">
            <InfinitySelect
              hideSelectedOptions
              isSearchable
              placeholder="Выберите типы событий"
              isDisabled={isVirtual || pending || isDisabled}
              isLoading={pending}
              options={eventTypesOptions}
              value={null}
              onChange={({ target: { value: option } }) => {
                updateList({
                  basicUrl: getBasicUrl(id),
                  name: LIST_NAME,
                  id: option.value,
                  item: option.data,
                })
                refreshList()
                return null
              }}
              components={{ Option }}
              infinityConfig={{
                searchBy: `name`,
                changeQuery: setQuery,
                queryParams: availableQuery,
              }}
            />
          </div>
        </FieldSet>
      </Box>
      {isVirtual && (
        <Box pl="2md" className={styles.FirstCreateLabel} loose>
          {createFirstText}
        </Box>
      )}
      <Box pt="2md">
        {!isVirtual && (
          <List
            planId={id}
            isLoading={pending}
            isVirtual={isVirtual}
            isDisabled={isDisabled}
            planEventTypeList={planEventTypeList}
            refreshList={refreshList}
          />
        )}
        {isVirtual && planTypeId && <ReadOnlyList planTypeId={planTypeId} />}
      </Box>
    </Box>
  )
}

EventTypePart.propTypes = {
  id: PropTypes.oneOf([`string`, `number`]),
  isVirtual: PropTypes.bool,
  planEventTypeList: PropTypes.shape({
    color: PropTypes.string,
    name: PropTypes.string,
    id: PropTypes.number,
  }).isRequired,
  updateList: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool.isRequired,
}

EventTypePart.defaultProps = {
  id: null,
  isVirtual: false,
}

export default connect(
  state => ({
    planEventTypeList: selectCurrentList(state, LIST_NAME),
  }),
  {
    updateList,
  },
)(EventTypePart)
